import en from './en-US';
import fr from './fr-CA';
import de from './de-DE';
import pt from './pt-BR';
import es from './es-ES';
import ru from './ru-RU';
import pl from './pl-PL';
import el from './el-GR';
import zh from './zh-ZH';
import it from './it-IT';
import hu from './hu-HU';
import cs from './cs-CS';
import da from './da-DK';
import fi from './fi-FI';
import no from './no-NO';
import sv from './sv-SE';
import chat from './chat';
import accountEmailChange from './accountEmailChange';
import session from './session';
import pwaInstall from './pwaInstall';

const baseMessages = {
  ...en,
  ...fr,
  ...de,
  ...pt,
  ...es,
  ...ru,
  ...pl,
  ...el,
  ...zh,
  ...it,
  ...hu,
  ...cs,
  ...da,
  ...fi,
  ...no,
  ...sv
};

const messages = Object.entries(baseMessages).reduce(
  (localizedMessages, [locale, localeMessages]) => ({
    ...localizedMessages,
    [locale]: {
      ...localeMessages,
      ...(chat[locale] ?? chat['en-us']),
      ...(accountEmailChange[locale] ?? accountEmailChange['en-us']),
      ...(session[locale] ?? session['en-us']),
      ...(pwaInstall[locale] ?? pwaInstall['en-us'])
    }
  }),
  {}
);

export default messages;
